import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import Pagination from "../Pagination/Paginations.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import "../preloading.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const EmployeeReport = () => {
  const today = new Date().toISOString().split("T")[0];

  const [filters, setFilters] = useState({
    start_date: today,
    end_date: today,
    status_type: "-1",
    reason_status: "",
    action_type: "Fetch",
  });

  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  // reason status only applies to employees who have left, so it is offered
  // for the Inactive status and cleared whenever the status moves off it
  const showReasonStatus = filters.status_type === "0";

  // ✅ Handle input changes
  const handleInput = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "status_type" && value !== "0" ? { reason_status: "" } : {}),
    }));
  };

  // ✅ Fetch employee report
  const handleSubmit = async (e) => {
    e.preventDefault();
    // block repeat clicks while a request is already running
    if (loadingRef.current) return;
    loadingRef.current = true;
    setLoading(true);

    try {
      const res = await axios.post(
        API_BASE_URL + "/employee_report", // 🔹 Laravel endpoint
        {
          start_date: filters.start_date,
          end_date: filters.end_date,
          status_type: filters.status_type,
          reason_status: showReasonStatus ? filters.reason_status : "",
          action_type: filters.action_type,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (res.data.status === 200 || Array.isArray(res.data.records)) {
        setRecords(res.data.records || []);
        toast.success("Employee report loaded successfully!", {
          position: "bottom-right",
          theme: "colored",
          toastId: "employee-report-success",
        });
      } else {
        setRecords([]);
        toast.warn(res.data.message || "No records found", {
          position: "bottom-right",
          theme: "colored",
          toastId: "employee-report-warn",
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching employee report", {
        position: "bottom-right",
        theme: "colored",
        toastId: "employee-report-error",
      });
    } finally {
      loadingRef.current = false;
      setLoading(false);
    }
  };

  // ✅ Filter + Pagination Logic
  const filteredItems = records.filter((item) =>
    `${item.employee_id}${item.employee_name}${item.department}${item.date_of_joining}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const paginatedData = filteredItems.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  return (
    <>
      <div className="container-fluid mt-4">
        <ToastContainer />

        {/* 🔹 Filter Form */}
        <div className="card shadow-sm mb-4">
          <h6 className="card-header d-flex align-items-center" style={{ color: "#1d3a8a", fontWeight: 600 }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
              <path fillRule="evenodd" d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.017-1.694a.5.5 0 1 1 .858.257z"/>
              <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
              <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
            </svg>
            Employee Report
          </h6>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3 align-items-end">
                {/* From Date */}
               <div className="col-md-2">
  <label htmlFor="start_date">From Date</label>

  <DatePicker
    selected={filters.start_date ? new Date(filters.start_date) : null}
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString("en-CA")
        : "";

      setFilters((prev) => ({
        ...prev,
        start_date: value,
      }));
    }}
    dateFormat="yyyy-MM-dd"
    placeholderText="Select From Date"
    className="form-control"
    maxDate={filters.end_date ? new Date(filters.end_date) : null}
    required
  />
</div>

{/* To Date */}
<div className="col-md-2">
  <label htmlFor="end_date">To Date</label>

  <DatePicker
    selected={filters.end_date ? new Date(filters.end_date) : null}
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString("en-CA")
        : "";

      setFilters((prev) => ({
        ...prev,
        end_date: value,
      }));
    }}
    dateFormat="yyyy-MM-dd"
    placeholderText="Select To Date"
    className="form-control"
    minDate={filters.start_date ? new Date(filters.start_date) : null}
    required
  />
</div>


                {/* Status */}
                <div className="col-md-2">
                  <label htmlFor="status_type">Status</label>
                  <select
                    className="form-control"
                    style={{ height: "38px" }}
                    name="status_type"
                    value={filters.status_type}
                    onChange={handleInput}
                  >
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                    <option value="-1">All</option>
                  </select>
                </div>

                {/* Reason Status - only meaningful for employees who have left */}
                {showReasonStatus && (
                  <div className="col-md-2">
                    <label htmlFor="reason_status">Reason Status</label>
                    <select
                      className="form-control"
                      style={{ height: "38px" }}
                      name="reason_status"
                      value={filters.reason_status}
                      onChange={handleInput}
                    >
                      <option value="">All</option>
                      <option value="Terminate">Terminate</option>
                      <option value="Abscond">Abscond</option>
                      <option value="Resigned">Resigned</option>
                    </select>
                  </div>
                )}

                {/* Action */}


                {/* Submit */}
                <div className="col-md-2">
                  <button type="submit" className="btn btn-primary btn-sm" style={{ height: "38px" }} disabled={loading}>
                    {loading ? "Loading..." : "Get"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* 🔹 Table Section */}
        <div className="card">
          <div className="card-body">
            {/* Top Controls */}
            <div className="d-flex justify-content-between mb-2 align-items-center">
              <div
                className="d-flex align-items-center gap-2"
                style={{ width: "auto", minWidth: "220px" }}
              >
                <DownloadButtons data={filteredItems} filename="Employee_Report" />
              </div>

              <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                <EntriesSelector
                  setEntriesPerPage={setEntriesPerPage}
                  setCurrentPage={setCurrentPage}
                />
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search..."
                  style={{ width: "200px" }}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            {/* Table */}
            {loading ? (
              <div className="d-flex justify-content-center p-5">
                <div className="spinner"></div>
              </div>
            ) : (
              <div className="table-responsive sticky-table-wrap">
                <table className="table table-bordered table-striped sticky-table sticky-head-tint sticky-no-freeze-col">
                  <thead>
                    <tr>
                      <th>Employee ID</th>
                      <th>Employee Name</th>
                      <th>Department</th>
                      <th>Date of Joining</th>
                      <th>Status</th>
                      <th>Reason Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length > 0 ? (
                      paginatedData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.employee_id}</td>
                          <td>{row.employee_name}</td>
                          <td>{row.department_name}</td>
                          <td>{row.date_of_joining}</td>
                          <td>
                            <span
                              className={`badge ${
                                row.is_active === 1
                                  ? "bg-success"
                                  : "bg-secondary"
                              }`}
                            >
                              {row.is_active === 1 ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td>{row.reason_status || "-"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="6"
                          className="text-center text-danger fw-bold"
                        >
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeReport;
